<template>
  <div id="main-layout" :class="{ sidebar: mapLayoutSidebar }">
    <section class="topbar">
      <div class="menu-button d-flex align-items-center p-1">
        <b-button variant="primary" class="shadow-none" @click="toggleMainMenuSidebar">
          <i class="far fa-bars"></i>
        </b-button>
      </div>
      <div class="logo d-flex justify-content-center">
        <img src="@/assets/img/bm-logo-white.svg" />
      </div>

      <div class="view-info">
        <!-- Put the view title here -->
      </div>

      <div class="user-buttons">
        <div class="item">
          <i class="fas fa-comment-alt"></i>
        </div>
        <div class="item">
          <i class="fas fa-ellipsis-v"></i>
          <i class="fas fa-ellipsis-v"></i>
          <i class="fas fa-ellipsis-v"></i>
        </div>
      </div>
    </section>

    <section class="sidebar">
      <div class="mask" @click="toggleMainMenuSidebar"></div>
      <MainMenu />
    </section>

    <section class="main">
      <transition name="fade-in">
        <router-view />
      </transition>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import MainMenu from '@/components/layout/MainMenu.vue'

@Component({
  components: {
    MainMenu
  }
})
export default class MainLayout extends Vue {
  get mapLayoutSidebar () {
    return this.$store.state.global.mapLayoutSidebar
  }

  toggleMainMenuSidebar () {
    this.$store.commit('global/toggleMapLayoutSidebar')
  }

  created () {
    if (this.mapLayoutSidebar) {
      this.toggleMainMenuSidebar()
    }
  }
}
</script>

<style lang="scss" scoped>
#main-layout {
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-flow: column nowrap;

  section.sidebar {
    position: fixed;
    z-index: 99;
    top: var(--topbar-height);
    left: calc(var(--sidebar-width) * -1);
    bottom: 0;
    width: var(--sidebar-width);
    transition: all 250ms ease-out;
    box-shadow: 0 0 5px #acacac;
    overflow: visible;
    display: flex;
    flex-flow: column nowrap;
    background-color: var(--sidebar-bg-color);
    .mask {
      content: '';
      position: fixed;
      top: var(--topbar-height);
      left: 0;
      right: 100%;
      bottom: 0;
      background: rgba(#000, 0.5);
      opacity: 0;
      transition: opacity 350ms ease 150ms;
    }
  }

  section.topbar {
    background-color: var(--primary);
    box-shadow: 0 0 2px #dddddd;
    z-index: 1;
    height: var(--topbar-height);
    display: flex;
    flex-flow: row nowrap;
    color: #fff;

    .logo {
      width: 150px;
      padding: 9px 0;
      img {
        width: 100%;
      }
    }

    .view-info {
      flex: 1;
    }

    .user-buttons {
      width: 120px;
      display: flex;
      justify-content: flex-end;
      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.25rem;
        padding: 0 15px;
        cursor: pointer;
        &:hover {
          background-color: var(--primary-color-hover);
        }
      }
    }
  }

  section.main {
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
    margin: 0;
    transition: all 250ms ease-out;
  }

  &.sidebar {
    section.sidebar {
      left: 0px;
      .mask {
        left: var(--sidebar-width);
        right: 0;
        opacity: 1;
      }
    }
  }
}
</style>
